import { AnyAction } from "redux";
import { SET_UNREAD_COUNT } from "./notificationVariables";

interface NotificationState {
  unreadCount: number;
}

const initialState: NotificationState = {
  unreadCount: 0,
};

const notificationReducer = (state: NotificationState = initialState, action: AnyAction): NotificationState => {
  switch (action.type) {
    case SET_UNREAD_COUNT:
      return { ...state, unreadCount: action.unreadCount };
    default:
      return state;
  }
};

export default notificationReducer;
